import BaseButton from 'core/buttons/base-button';
import dynamic from 'next/dynamic';
import formatNumber from 'utils/format-number';
import getRoundedNumber from 'utils/get-rounded-number';
import PriceTagItem from 'components/landing/tables/components/price-tag/price-tag-item';
import PropTypes from 'prop-types';
import RangeIndicator from 'components/landing/tables/components/slider-indicator/slider-indicator';
import styles from 'styles/SmallItemBase.module.scss';
import useRichTranslation from 'hooks/useRichTranslation';
import variables from 'styles/variables.module.scss';

const CarIconMapper = dynamic(() => import('components/icons/landing/car-brand-icons/mapper'));

const QuotationAvailableByCarSmallItem = ({
    buttonLabel,
    buttonHref,
    carBrand,
    carName,
    colorSchema,
    familyName,
    price,
    peopleChoice
}) => {
    const t = useRichTranslation('table');
    // const CarLogo = carIconMapper(carBrand);
    const roundedPrice = formatNumber(getRoundedNumber(price));

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div style={{ backgroundColor: colorSchema }}>
                    {carBrand && (
                        <CarIconMapper input={carBrand} color={variables.whiteColor} height={22} />
                    )}
                    <p>{carName}</p>
                </div>
            </div>
            <div className={styles.content}>
                <div>
                    <PriceTagItem
                        tagType="price-label"
                        value={roundedPrice}
                        fontSize={20}
                    />
                    <p className={styles.family_name}>{familyName}</p>
                </div>
                <div style={{ backgroundColor: variables.grayColor }}>
                    <div className={styles.range__wrapper}>
                        <p className={styles.label}>
                            <strong>{peopleChoice}% </strong>
                            {t('quotation-available-by-car.item.people-choice')}
                        </p>
                        <RangeIndicator
                            range={100}
                            width={140}
                            value={peopleChoice}
                            colorSchema={colorSchema}
                        />
                    </div>
                    <BaseButton
                        href={buttonHref}
                        divClass={styles.button__wrapper}
                        buttonClass={styles.button}
                        label={buttonLabel}
                    />
                </div>
            </div>
        </div>
    );
};

QuotationAvailableByCarSmallItem.propTypes = {
    buttonLabel: PropTypes.string,
    carBrand: PropTypes.string,
    carName: PropTypes.string,
    colorSchema: PropTypes.string,
    familyName: PropTypes.string,
    price: PropTypes.number,
    peopleChoice: PropTypes.number,
    buttonHref: PropTypes.string
};

export default QuotationAvailableByCarSmallItem;
